<template>
  <expansion-section-block
    :title="$t('sections.guest')"
    :subtitle="'#' + guest.id"
    :otherOptions="true"
    otherOptionsColor="quaternary"
    :subsection="true"
    color="tertiary">
    <!-- @footerAddonClick="$emit('removeGuest', guest)" -->
    <template v-slot:body>
      <v-row>
        <v-col cols="6" sm="3" class="py-0">
          <v-text-field :label="$t('form.mandatory.name')"
            v-model="name"
            :error-messages="!name && showErrors ? $t('errors.mandatory') : []"
            :disabled="!editable"/>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <v-text-field :label="$t('form.last_name')"
            v-model="lastName" :disabled="!editable"/>
        </v-col>
        <v-col cols="12" sm="6" class="py-0">
          <v-text-field :label="$t('form.email')"
            v-model="email" :disabled="!editable"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" class="py-0">
          <v-text-field :label="$t('form.phone_number')"
            v-model="phoneNumber" :disabled="!editable"/>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <date-input :label="$t('form.birth_date')"
            :clearable="true"
            :initialDate="dateOfBirth"
            @change="v => dateOfBirth = v" :disabled="!editable"/>
        </v-col>
        <v-col cols="12" sm="6" class="py-0">
          <v-autocomplete :label="$t('form.language')"
            :items="languageCodes"
            item-text="name"
            item-value="code"
            v-model="languageCode" :disabled="!editable">
            <template v-slot:selection="{ item }">{{ item.name }}</template>
            <template v-slot:item="{ item }">{{ item.name }}</template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-radio-group :label="$t('form.gender')" v-model="gender">
            <v-row>
              <v-col>
                <div class="d-inline-flex flex-wrap">
                  <v-flex class="pr-5" :class="{'py-2': $vuetify.breakpoint.xsOnly}">
                    <v-radio key="male"
                      :label="$t('form.genders.MALE')"
                      value="MALE" :disabled="!editable"/>
                  </v-flex>
                  <v-flex class="pr-5" :class="{'py-2': $vuetify.breakpoint.xsOnly}">
                    <v-radio key="female"
                      :label="$t('form.genders.FEMALE')"
                      value="FEMALE" :disabled="!editable"/>
                  </v-flex>
                  <v-flex class="pr-5" :class="{'py-2': $vuetify.breakpoint.xsOnly}">
                    <v-radio key="other"
                      :label="$t('form.genders.OTHER')"
                      value="OTHER" :disabled="!editable"/>
                  </v-flex>
                </div>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" class="pb-0">
          <date-input :label="$t('form.mandatory.checkin_date')"
            :initialDate="checkInDate"
            @change="v => { checkInDate = v }"/>
        </v-col>
        <v-col cols="6" sm="3" class="pb-0">
          <time-input :label="$t('form.mandatory.checkin_time')"
            :initialTime="checkInTime"
            @change="v => { checkInTime = v }"/>
        </v-col>
        <v-col cols="6" sm="3" class="pb-0">
          <date-input :label="$t('form.checkout_date')"
            :initialDate="checkOutDate"
            @change="v => { checkOutDate = v }"/>
        </v-col>
        <v-col cols="6" sm="3" class="pb-0">
          <time-input :label="$t('form.checkout_time')"
            :initialTime="checkOutTime"
            @change="v => { checkOutTime = v }"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:otherOptions>
      <v-row>
        <v-col cols="6" sm="3" class="py-0">
          <v-autocomplete :label="$t('form.profile_type')"
            :items="profileTypes.list"
            item-text="name"
            item-value="id"
            v-model="profileTypeId" :disabled="!editable">
            <template v-slot:selection="{ item }">{{ item.name }}</template>
            <template v-slot:item="{ item }">{{ item.name }}</template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <v-autocomplete :label="$t('form.profile_category')"
            :items="profileCategories.list"
            item-text="name"
            item-value="id"
            v-model="profileCategoryId" :disabled="!editable">
            <template v-slot:selection="{ item }">{{ item.name }}</template>
            <template v-slot:item="{ item }">{{ item.name }}</template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <v-autocomplete :label="$t('form.guest_type')"
            :items="guestTypes.list"
            item-text="name"
            item-value="id"
            v-model="guestTypeId">
            <template v-slot:selection="{ item }">{{ item.name }}</template>
            <template v-slot:item="{ item }">{{ item.name }}</template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <v-autocomplete :label="$t('form.guest_category')"
            :items="guestCategories.list"
            item-text="name"
            item-value="id"
            v-model="guestCategoryId">
            <template v-slot:selection="{ item }">{{ item.name }}</template>
            <template v-slot:item="{ item }">{{ item.name }}</template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </template>
  </expansion-section-block>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import languageCodes from '@/config/languages'
export default {
  props: {
    guest: Object,
    showErrors: Boolean
  },
  data () {
    return {
      edited: {
        name: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        dateOfBirth: null,
        gender: null,
        languageCode: null,
        profileTypeId: null,
        profileCategoryId: null,
        guestTypeId: null,
        guestCategoryId: null,
        checkInDate: null,
        checkOutDate: null,
        checkInTime: null,
        checkOutTime: null
      },
      languageCodes
    }
  },
  watch: {
    guest: {
      handler: function (value) {
        this.edited.dateOfBirth = value.profile.dateOfBirth ? moment(value.profile.dateOfBirth).format('YYYY-MM-DD') : null
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(['state', 'profiles', 'profileTypes', 'profileCategories', 'rooms', 'guestTypes', 'guestCategories']),
    editable () {
      return this.guest.profile.id !== this.profiles.read.id
    },
    editedGuest () {
      const guest = this.guest
      // set changes
      guest.profile.name = this.name
      guest.profile.lastName = this.lastName
      guest.profile.email = this.email
      guest.profile.phoneNumber = this.phoneNumber
      guest.profile.dateOfBirth = this.dateOfBirth ? moment(this.dateOfBirth).add(12,'h').format('YYYY-MM-DDTHH:mm:ss.SSSZZ') : null
      guest.profile.gender = this.gender
      guest.profile.languageCode = this.languageCode
      guest.profile.typeId = this.profileTypeId
      guest.profile.categoryId = this.profileCategoryId
      guest.typeId = this.guestTypeId
      guest.categoryId = this.guestCategoryId
      guest.checkin = this.checkInDate && this.checkInTime ? moment(this.checkInDate + 'T' + this.checkInTime).format('YYYY-MM-DDTHH:mm:ss.SSSZZ') : null
      guest.checkout = this.checkOutDate && this.checkOutTime ? moment(this.checkOutDate + 'T' + this.checkOutTime).format('YYYY-MM-DDTHH:mm:ss.SSSZZ') : null
      return guest
    },
    name: {
      get () {
        return this.edited.name || this.guest.profile.name
      },
      set (value) {
        this.edited.name = value
        this.$emit('input', this.editedGuest)
      }
    },
    lastName: {
      get () {
        return this.edited.lastName || this.guest.profile.lastName
      },
      set (value) {
        this.edited.lastName = value
        this.$emit('input', this.editedGuest)
      }
    },
    email: {
      get () {
        return this.edited.email || this.guest.profile.email
      },
      set (value) {
        this.edited.email = value
        this.$emit('input', this.editedGuest)
      }
    },
    phoneNumber: {
      get () {
        return this.edited.phoneNumber || this.guest.profile.phoneNumber
      },
      set (value) {
        this.edited.phoneNumber = value
        this.$emit('input', this.editedGuest)
      }
    },
    dateOfBirth: {
      get () {
        return Object.hasOwn(this.edited, 'dateOfBirth') ? this.edited.dateOfBirth : (this.guest.profile.dateOfBirth ? moment(this.guest.profile.dateOfBirth).format('YYYY-MM-DD') : null)
      },
      set (value) {
        this.edited.dateOfBirth = value
        this.$emit('input', this.editedGuest)
      }
    },
    gender: {
      get () {
        return this.edited.gender || this.guest.profile.gender
      },
      set (value) {
        this.edited.gender = value
        this.$emit('input', this.editedGuest)
      }
    },
    languageCode: {
      get () {
        return this.edited.languageCode || this.guest.profile.languageCode
      },
      set (value) {
        this.edited.languageCode = value
        this.$emit('input', this.editedGuest)
      }
    },
    profileTypeId: {
      get () {
        return this.edited.profileTypeId || this.guest.profile.typeId
      },
      set (value) {
        this.edited.profileTypeId = value
        this.$emit('input', this.editedGuest)
      }
    },
    guestTypeId: {
      get () {
        return this.edited.guestTypeId || this.guest.typeId
      },
      set (value) {
        this.edited.guestTypeId = value
        this.$emit('input', this.editedGuest)
      }
    },
    profileCategoryId: {
      get () {
        return this.edited.profileCategoryId || this.guest.profile.categoryId
      },
      set (value) {
        this.edited.profileCategoryId = value
        this.$emit('input', this.editedGuest)
      }
    },
    guestCategoryId: {
      get () {
        return this.edited.guestCategoryId || this.guest.categoryId
      },
      set (value) {
        this.edited.guestCategoryId = value
        this.$emit('input', this.editedGuest)
      }
    },
    checkInDate: {
      get () {
        return this.edited.checkInDate || (this.guest.checkin ? moment(this.guest.checkin).format('YYYY-MM-DD') : null)
      },
      set (value) {
        this.edited.checkInDate = value
        this.$emit('input', this.editedGuest)
      }
    },
    checkInTime: {
      get () {
        return this.edited.checkInTime || (this.guest.checkin ? moment(this.guest.checkin).format('HH:mm') : null)
      },
      set (value) {
        this.edited.checkInTime = value
        this.$emit('input', this.editedGuest)
      }
    },
    checkOutDate: {
      get () {
        return this.edited.checkOutDate || (this.guest.checkout ? moment(this.guest.checkout).format('YYYY-MM-DD') : null)
      },
      set (value) {
        this.edited.checkOutDate = value
        this.$emit('input', this.editedGuest)
      }
    },
    checkOutTime: {
      get () {
        return this.edited.checkOutTime || (this.guest.checkout ? moment(this.guest.checkout).format('HH:mm') : null)
      },
      set (value) {
        this.edited.checkOutTime = value
        this.$emit('input', this.editedGuest)
      }
    }
  },
  components: {
    ExpansionSectionBlock: () => import('@/components/ExpansionSectionBlock.vue'),
    DateInput: () => import('@/components/app-components/DateInput.vue'),
    TimeInput: () => import('@/components/app-components/TimeInput.vue')
  }
}
</script>